// required to register them for JSON serialize/deserialize
//
export default [
  require("./ExtLabel"),
  require("./DecoratedInputPort"),
  require("./ExtLine"),
  require("./ExtPolygon"),
  require("./ExtPort"),
  require("./MarkerFigure"),
  require("./MarkerStateAFigure"),
  require("./MarkerStateBFigure"),
  require("./PolyCircle"),
  require("./PolyRect"),
  require("./TestSwitch")
]

